"use strict";
// Copyright (c) StrangeBee 2024
Object.defineProperty(exports, "__esModule", { value: true });
const __1 = require("..");
class ConfigController extends __1.ParentController {
    constructor() {
        super(...arguments);
        this.endpoints = {
            getLdapServers: '/config/syncUser.ldap.servers',
            editLdapServers: '/config/syncUser.ldap.servers',
        };
    }
    getLdapServers() {
        return this.manager.get({ url: this.endpoints.getLdapServers });
    }
    editLdapServers(data) {
        return this.manager.put({ url: this.endpoints.editLdapServers }, data);
    }
}
exports.default = ConfigController;
